import { FAQContainer, FAQElement } from 'components/shared/FAQ';
import { Container } from '..';
import styles from './FAQSection.module.css';

export const faqData = [
  {
    title: 'What is Rare?',
    description: (
      <>
        Rare is the world&apos;s first luxury smart ring.
        <br />
        <br />
        It is meticulously handcrafted by skilled artisans. Using expert
        metalworking techniques and advanced material engineering, they shape
        and texture precious materials with unparalleled precision and care.
        <br />
        <br />
        Rare launches with the “Desert Collection” with three distinctive
        pieces: Desert Rose, Desert Snow, and Dune. Rare&apos;s design captures
        the essence of nature&apos;s most captivating phenomena. From the
        intricate fluid elegance of wind-sculpted dunes, each piece embodies the
        harmonious blend of beauty and resilience found in these arid
        landscapes.
        <br />
        <br />
        These rings incorporate timeless elegance with advanced health
        technology incorporating photoplethysmography and 6-axis motion sensors.
        Individuals can monitor key health indicators such as sleep, movement,
        heart rate (HR), heart rate variability (HRV), stress and skin
        temperature.
      </>
    ),
  },
  {
    title: 'What are the available variants?',
    description: (
      <>
        Rare debuts with the Desert Collection. featuring three distinctive
        pieces:
        <br />
        <br />
        <ul>
          <li>Desert Rose</li>
          <li>Desert Snow</li>
          <li>Dune</li>
        </ul>
        <br />
        <br />
        Dune and Desert Rose rings are expertly crafted from 18K Gold. The gold
        has been sourced from London Bullion Market Association (LBMA) approved
        refineries and hallmarked by the Bureau of Indian Standards (BIS). Both
        the LBMA and BIS adhere to international standards, ensuring the highest
        level of authenticity and quality in precious metals.
        <br />
        <br />
        The Desert Snow ring is meticulously crafted from pt950 platinum, a
        metal of exceptional purity and prestige. Composed of 95% platinum,
        pt950 represents one of the highest standards in the jewellery industry,
        signifying unparalleled quality and durability.
      </>
    ),
  },
  {
    title: 'Is  Rare water-resistant and durable for everyday use?',
    description: (
      <>
        Yes, Rare is water-resistant and designed for everyday use, including
        swimming or exercising. Rare is meticulously handcrafted by skilled
        artisans, utilizing expert metalworking techniques to handle precious
        materials. These finishes and the intricate textures of the design are
        effects achieved entirely through expert metalworking that ensures
        durability.
      </>
    ),
  },
  {
    title: 'Where can I purchase Rare?',
    description: (
      <>
        Rare is exclusively available at select retail stores in London and
        Berlin. It will soon be available in various global locations such as
        New York, Milan, Dubai and India.
      </>
    ),
  },
  {
    title: 'What are some other benefits that come with Rare?',
    description: (
      <>
        Rare users enjoy a complimentary lifetime membership to UltrahumanX.
        They also get lifetime complimentary access to current and all future
        PowerPlugs, a platform for individual apps and plugins built on top of
        Ultrahuman&apos;s health and wellness data stack.
      </>
    ),
  },
];

export const FAQSection = ({
  faqData,
  htmlId,
}: {
  faqData: {
    title: string;
    description: React.ReactNode;
  }[];
  htmlId?: string;
}) => {
  return (
    <section className={styles.root} id={htmlId}>
      <Container>
        <h2>Frequently asked questions</h2>
        <FAQContainer>
          {faqData.map((faq, i) => {
            return <FAQElement key={i} {...faq} />;
          })}
        </FAQContainer>
      </Container>
    </section>
  );
};
